import userManager from "../auth/userManager";

// Resolves the Authorization header for outgoing API requests (see
// docs/specs/0001-oidc-migration.md) - the Bearer token from the OIDC
// library's session state (the shared userManager, so it stays consistent
// with what AuthProvider itself sees).
export async function resolveAuthorizationHeader() {
  const user = await userManager.getUser();
  return user?.access_token ? `Bearer ${user.access_token}` : null;
}
